exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".english.elBreadcrumb{height:.390625rem;line-height:.390625rem}.english .el-breadcrumb{height:100%;line-height:.390625rem;padding-left:1.875rem;font-size:.083333rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/px2rem-webpack-loader?{"baseDpr":1,"remUnit":192,"remPrecision":6,"forcePxComment":"px","keepComment":"no","remLimit":1,"exclude":{}}!./src/components/less/en_pageNav.css
// module id = 930
// module chunks = 0